import { render, staticRenderFns } from "./AssetCategoryPage.vue?vue&type=template&id=31bd197e&scoped=true&"
import script from "./AssetCategoryPage.vue?vue&type=script&lang=ts&"
export * from "./AssetCategoryPage.vue?vue&type=script&lang=ts&"
import style0 from "./AssetCategoryPage.vue?vue&type=style&index=0&id=31bd197e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd197e",
  null
  
)

export default component.exports